"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnexLegalDocumentsService = void 0;
class AnnexLegalDocumentsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getApiV1AnnexDpa({ locale, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/annex/dpa',
            query: {
                locale: locale,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
}
exports.AnnexLegalDocumentsService = AnnexLegalDocumentsService;
